<?xml version="1.0" encoding="UTF-8"?>
<svg id="f" data-name="ICONS" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20">
  <rect x="4" y="4" width="12" height="12" rx="2.25" ry="2.25" fill="var(--iconPrimary, #222)"/>
</svg>